export default __webpack_public_path__ + "static/media/lia.9399fc11.svg";